import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";
import {
  useMergeRefs
} from "./J7Q2EO23.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./PNRLI7OV.js";

// src/popover/popover-anchor.ts
var usePopoverAnchor = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = __spreadProps(__spreadValues({}, props), {
      ref: useMergeRefs(store.setAnchorElement, props.ref)
    });
    return props;
  }
);
var PopoverAnchor = createComponent((props) => {
  const htmlProps = usePopoverAnchor(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  PopoverAnchor.displayName = "PopoverAnchor";
}

export {
  usePopoverAnchor,
  PopoverAnchor
};
